module.exports = __webpack_public_path__ + "static/media/phone-telephone-call-svgrepo-com.7d92faf3.svg";